<style lang="scss" scoped>
.message {
  white-space: pre-wrap;
}
.male-icon {
  color: $male;
}
.female-icon {
  color: $female;
}
.alert-warning {
  color: black;
}
</style>

<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header"><strong>Nachricht</strong></div>
        <div class="card-body">
          <div class="message">{{ original.message }}</div>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="card">
        <div class="card-header"></div>
        <div class="card-body">
          <a v-if="hasProfile" :href="`/mitglieder/kartei/${profile.id}`">
            <img
              height="45"
              width="45"
              class="rounded-circle mr-2 link"
              :src="`${profile.primary_image.url}?width=45&height=45`"
            />
            {{ profile.name }}
            <i
              v-if="profile.sex == 'männlich'"
              class="fas fa-mars male-icon"
            ></i>
            <i
              v-else-if="profile.sex == 'weiblich'"
              class="fas fa-venus female-icon"
            ></i>
            <span v-if="isCustomerDeleted" class="badge badge-danger ml-3"
              >GELÖSCHT</span
            >
          </a>
          <span v-else>{{ original.name }}</span>
          <hr />
          <div class="row">
            <div class="col-5">Ticket ID:</div>
            <div class="col-7">{{ original.id }}</div>
            <div class="col-5">E-Mail:</div>
            <div class="col-7">{{ original.email }}</div>
            <div class="col-5">Kategorie:</div>
            <div class="col-7">{{ original.category }}</div>
            <div class="col-5">Browserinfo:</div>
            <div class="col-7">{{ original.user_agent }}</div>
            <div class="col-5">Auflösung:</div>
            <div class="col-7">{{ original.meta.monitor_resolution }}</div>
            <div class="col-5">Betriebsystem:</div>
            <div class="col-7">{{ os.name }} {{ os.version }}</div>
            <div class="col-5">Browser:</div>
            <div class="col-7">{{ browser.name }} {{ browser.version }}</div>
            <div class="col-5">Gerät:</div>
            <div class="col-7">{{ device.model }} {{ device.vendor }}</div>
            <div v-if="hasProfile" class="col-5">IP:</div>
            <div v-if="hasProfile" class="col-7">
              {{ original.ip }}
              <span class="flag-icon" :class="flagClass"></span>
            </div>
            <div class="col-5">Datum:</div>
            <div class="col-7">
              <span v-html="getDateFormatted(original.created_at)"></span>
            </div>
            <div v-if="hasProfile" class="col-5">{{ currency }}:</div>
            <div v-if="hasProfile" class="col-7">{{ profile.balance }}</div>
            <div class="col-5">Supportfälle:</div>
            <div class="col-7">{{ original.same_customer_cases }}</div>
          </div>

          <button
            v-if="hasProfile && !isCustomerDeleted"
            @click="deleteUser()"
            class="btn btn-danger"
          >
            Löschen
          </button>
          <button
            v-if="hasProfile && !isCustomerDeleted"
            @click="toggleUserDisabled()"
            class="btn btn-danger"
          >
            {{ userDisabledText }}
          </button>
          <button
            v-if="hasProfile && !isCustomerDeleted"
            @click="$modal.show('give-currency')"
            class="btn btn-warning"
          >
            {{ currency }} geben
          </button>

          <modal v-if="hasProfile && !isCustomerDeleted" name="give-currency">
            <section class="p-3">
              <h2>{{ currency }} für {{ profile.name }}</h2>
              <div class="form-group">
                <input
                  type="number"
                  class="form-control"
                  name="amount"
                  v-model="giveCurrencyAmount"
                  :placeholder="
                    `Wie viele ${currency} sollen gutgeschrieben werden?`
                  "
                />
              </div>
              <button
                @click="giveCurrency()"
                type="button"
                :disabled="disableModalActions"
                class="btn btn-primary"
              >
                {{ currency }} ausgeben
              </button>
            </section>
          </modal>
        </div>
      </div>
    </div>
    <div class="col-8">
      <div class="card">
        <div class="card-body">
          <select
            class="form-control"
            @change="setSelectedTemplate($event)"
            v-model="key"
          >
            <option
              :value="index"
              v-for="(template, index) in supportTicketResponseTemplates"
              :key="template.id"
              >{{ template.name }}</option
            >
          </select>
        </div>
      </div>
      <resource
        resource="supportTicketResponse"
        notification="Supportnachricht wurde gesendet"
        :attributes="[
          {
            name: 'support_ticket_id',
            value: this.id,
            type: 'hidden'
          },
          {
            name: 'to',
            label: 'To',
            value: original.email
          },
          {
            name: 'subject',
            label: 'Betreff',
            value: subject,
            updatable: true
          },
          {
            name: 'message',
            label: 'Nachricht',
            type: 'TextareaSelector',
            value: message,
            updatable: true
          }
        ]"
      >
        <div class="row">
          <div class="col-12">
            <div class="alert alert-warning">
              <strong>Automatisch angehängter Footer:</strong>
              <div v-html="settings.emailFooter"></div>
            </div>
          </div>
        </div>
      </resource>
    </div>
    <div class="col-12">
      <h4>Antworten</h4>
      <div
        v-for="response in original.support_ticket_responses"
        class="card"
        :key="response.id"
      >
        <div class="card-body">
          {{ response.to }} <br />
          <span v-html="getDateFormatted(response.created_at)"></span> <br />
          {{ response.subject }}
          <hr />
          <pre class="message">{{ response.message }}</pre>
        </div>
      </div>
    </div>
    <div class="col-12">
      <h4>andere Support Tickets</h4>
      <time-line type="simple">
        <time-line-item
          v-for="(ticket, key) in otherTickets"
          :key="key"
          inverted
          badge-type="info"
          badge-icon="nc-icon nc-email-85"
        >
          <badge slot="header" type="info">
            {{ ticket.category }}
          </badge>
          <div slot="content">
            bearbeitet am:
            <span v-html="getDateFormatted(ticket.read_at)"></span>
            <br />
            bearbeitet von: {{ ticket.read_by }}
            <br />
            <b>Nachricht:</b>
            <br />
            <pre>{{ ticket.message }}</pre>
            <b v-if="ticket.support_ticket_responses.length !== 0">Antworten</b>
            <span v-html="responses(ticket.support_ticket_responses)"></span>
          </div>
          <h6 slot="footer">
            <i class="far fa-clock"></i>
            <span v-html="getDateFormatted(ticket.created_at)"></span>
          </h6>
        </time-line-item>
      </time-line>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import { UAParser } from "ua-parser-js";
import { getDateTimeHtml } from "@/js/date";
import { TimeLine, TimeLineItem, Badge } from "src/components/UIComponents";

export default {
  components: {
    TimeLine,
    TimeLineItem,
    Badge
  },
  beforeRouteEnter(to, from, next) {
    let p1 = store.dispatch("supportTicketResponseTemplate/read");
    let p2 = store.dispatch("supportTicket/read", [
      {
        name: "where",
        attributes: {
          id: [Number(to.params.id)]
        }
      }
    ]);
    Promise.all([p1, p2]).finally(() => next());
  },
  created() {
    this.getOtherTickets();
    const parser = new UAParser(this.original.user_agent);
    this.browser = parser.getBrowser();
    this.device = parser.getDevice();
    this.os = parser.getOS();

    this.$store.dispatch("setting/all").then(() => {
      this.settings = this.$store.getters["setting/all"];
    });
  },
  data() {
    return {
      selectedTemplate: { name: "", subject: "", message: "" },
      key: [],
      message: "",
      subject: "",
      browser: null,
      device: null,
      os: null,
      deleting: false,
      giveCurrencyAmount: null,
      disableModalActions: false,
      settingUserDisabled: false,
      settings: {},
      otherTickets: {}
    };
  },
  computed: {
    id() {
      return Number(this.$route.params.id);
    },
    original() {
      return this.$store.getters["supportTicket/find"](this.id);
    },
    hasProfile() {
      return this.original.customer_profile !== null;
    },
    profile() {
      return this.original.customer_profile;
    },
    supportTicketResponseTemplates() {
      return this.$store.getters[
        "supportTicketResponseTemplate/supportTicketResponseTemplates"
      ];
    },
    flagClass() {
      return this.original.ip_country.country
        ? `flag-icon-${this.original.ip_country.country.toLowerCase()}`
        : null;
    },
    currency() {
      return Laravel.lang.currency;
    },
    isCustomerDeleted() {
      return (
        this.original.customer_profile &&
        Boolean(this.original.customer_profile.deleted_at)
      );
    },
    userDisabledText() {
      return this.isDisabled ? "Entsperren" : "Sperren";
    },
    isDisabled() {
      if (!this.profile.user) {
        return false;
      }
      return Boolean(this.profile.user.disabled_at);
    }
  },
  methods: {
    responses(responses) {
      let output = "";
      let self = this;
      responses.forEach(function(response) {
        output +=
          `<hr>
          Betreff: ` +
          response.subject +
          ` <br>
          geantwortet am: ` +
          self.getDateFormatted(response.created_at) +
          ` <br>
          Nachricht: <br>
          <pre>` +
          response.message +
          `</pre>`;
      });
      return output;
    },
    toggleUserDisabled() {
      if (this.isDisabled) {
        this.enableUser();
      } else {
        this.disableUser();
      }
    },
    disableUser() {
      if (this.isDisabled || this.settingUserDisabled) {
        return;
      }

      this.settingUserDisabled = true;

      this.$http
        .post("/api/v1/userDisabled", {
          user_id: this.profile.user.id,
          message: null
        })
        .then(({ data }) => {
          this.$store.commit("customerProfile/updateModel", {
            modelId: this.profile.id,
            attributePath: "user.disabled_at",
            data: data
          });
          this.$notify({
            title: `${this.profile.name} wurde gesperrt`,
            type: "success"
          });
        })
        .finally(() => {
          this.settingUserDisabled = false;
        });
    },
    enableUser() {
      if (!this.isDisabled || this.settingUserDisabled) {
        return;
      }

      this.settingUserDisabled = true;

      this.$http
        .delete(`/api/v1/userDisabled/${this.profile.user.id}`)
        .then(() => {
          this.$store.commit("customerProfile/updateModel", {
            modelId: this.profile.id,
            attributePath: "user.disabled_at",
            data: undefined
          });
          this.$notify({
            title: `${this.profile.name} wurde entsperrt`,
            type: "success"
          });
        })
        .finally(() => {
          this.settingUserDisabled = false;
        });
    },
    getDateFormatted() {
      return getDateTimeHtml(...arguments);
    },
    setSelectedTemplate(event) {
      const template = this.supportTicketResponseTemplates[event.target.value];

      this.subject = template.subject;
      this.message = template.message;
    },
    giveCurrency() {
      this.disableModalActions = true;
      this.$http
        .post("/api/v1/admin-actions/give-currency", {
          customer_profile_id: this.profile.id,
          amount: this.giveCurrencyAmount
        })
        .then(() => {
          this.$modal.hide("give-currency");
          this.$notify({
            title: `${this.profile.name} hat ${this.giveCurrencyAmount} ${this.currency} erhalten`,
            type: "success"
          });
        })
        .finally(() => {
          this.disableModalActions = false;
        });
    },
    deleteUser() {
      if (this.deleting) {
        return;
      }

      let confirmed = confirm("Sicher?");
      if (!confirmed) {
        return;
      }

      this.deleting = true;

      this.$http
        .post("/api/v1/admin-actions/delete/user/" + this.profile.user_id)
        .then(() => {
          this.$notify({
            title: `${this.profile.name} wurde gelöscht`,
            type: "success"
          });

          this.$router.push("/mitglieder/support");
        })
        .finally(() => {
          this.deleting = false;
        });
    },
    getOtherTickets() {
      if (!this.profile) {
        return;
      }
      let filter = [
        {
          name: "where",
          attributes: {
            name: [this.profile.name],
            id: { value: this.id, operator: "!=" }
          }
        },
        {
          name: "with",
          value: "supportTicketResponses"
        }
      ];
      this.$http
        .get("/api/v1/supportTicket", { params: { filter: filter } })
        .then(({ data }) => {
          this.otherTickets = data;
        });
    }
  }
};
</script>
